module.exports = __webpack_public_path__ + "static/media/14UNEP18.86a29ad3.jpg";